<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    :wrapperClosable="false"
    title="确认收款"
    :visible="show"
    :before-close="beforeCloseDialog"
    @dialogclose="beforeCloseDialog"
  >
    <i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <div slot="title" class="dialog-header-title">
      <span class="name">确认收款</span>
    </div>
    <div class="form_content">
      <el-form :model="formData" :rules="rules" ref="ruleForm" style="padding: 20px" label-width="120px" class="demo-ruleForm">
        <el-row class="form_head_title"> 客户信息 </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="付款单编号:" prop="payment_no">
              <el-input v-model="formData.payment_no" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款单日期:" prop="payment_time">
              <el-date-picker style="width: 100%" v-model="formData.payment_time" format="yyyy-MM-dd" placeholder="选择日期" disabled> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="客户名称:" prop="customer_name">
              <el-input v-model="formData.customer_name" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系人:" prop="contacts">
              <el-input v-model="formData.contacts" disabled> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话:" prop="contacts_phone">
              <el-input v-model="formData.contacts_phone" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title"> 订单信息 </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="订单编号:" prop="order_no">
              <el-input v-model="formData.order_no" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单日期:" prop="order_time">
              <el-date-picker style="width: 100%" v-model="formData.order_time" format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" disabled> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产品名称:" prop="account_name">
              <el-input v-model="formData.account_name" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单金额:" prop="order_amount">
              <form-input :numberVal="formData.order_amount" :disabled="tenantId != '-1'" @setVal="setVal" :keyName="'order_amount'"></form-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title"> 付款信息 </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="付款金额:" prop="payment_amount">
              <form-input :numberVal="formData.payment_amount" :disabled="tenantId != '-1'" @setVal="setVal" :keyName="'payment_amount'"></form-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="付款方式:" style="margin-bottom: 0px" prop="pay_method">
              <el-select v-model="formData.pay_method" style="width: 100%" placeholder="请选择" disabled>
                <el-option v-for="item in paymentList" :key="item.code" :label="item.name" :value="item.code"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="form_head_title"> 付款后确认 </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="实际收款:" prop="pay_amount">
              <form-input :numberVal="formData.pay_amount" :disabled="false" @setVal="setVal" :keyName="'pay_amount'"></form-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="审核人:" prop="reviewer_name">
              <el-input v-model="formData.reviewer_name" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话:" prop="reviewer_phone">
              <el-input v-model="formData.reviewer_phone" placeholder="保存后自动生成" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="审核时间:" prop="audit_date">
              <el-date-picker v-model="formData.audit_date" format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" disabled> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="审核意见:" prop="audit_remark">
          <el-input v-model="formData.audit_remark" type="textarea" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="demo-drawer__footer">
      <el-button @click="beforeCloseDialog">取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">保存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import utils from '@/utils.js'
import FormInput from './formInput.vue'
export default {
  components: { FormInput },
  data() {
    return {
      drawerSize: '70%',
      formData: {
        pay_amount: 0,
        reviewer_name: '',
        reviewer_phone: '',
        audit_date: '',
        audit_remark: '',
        payment_time: '',
        payment_no: '',
        payment_amount: 0,
        pay_method: '1',
        payment_status: '1',
        tachment: '',
        order_no: '',
        order_time: '',
        customer_name: '',
        customer_id: '',
        create_user: '',
        contacts: '',
        contacts_phone: '',
        account_key: '',
        account_name: '',
        account_status: '',
        contacts_package: '',
        remark: '',
        recharge_years: 0,
        users_number: 0,
        purchases_number: 0,
        order_amount: 0,
        remarks: ''
      },
      rules: {
        reviewer_results: [{ required: true, message: '请确认审核结果！', trigger: 'blur' }]
      },
      paymentList: [
        { name: '对公转账', code: '1' },
        { name: '支付宝', code: '2' },
        { name: '微信', code: '3' }
      ],
      loading: false,
      tenantId: ''
    }
  },
  props: {
    show: {
      type: Boolean,
      default: () => false
    },
    paymentId: {
      type: String,
      default: () => ''
    }
  },
  mounted() {
    this.loadData()
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.loadData()
        }
      },
      deep: true
    }
  },
  methods: {
    loadData() {
      this.formData.audit_date = utils.formatDate(new Date())
      this.formData.reviewer_name = this.$store.state.user.currentUserDetail.user.fullname
      this.formData.reviewer_phone = this.$store.state.user.currentUserDetail.user.mobile
      if (this.paymentId) {
        this.$http.get('${third}/costcenter/third_payment/' + this.paymentId).then((res) => {
          if (res.data) {
            this.formData.refId = res.data.id
            const a = this.formData
            const b = res.data
            const newObject = {}
            Object.assign(newObject, a, b)
            this.formData = newObject
          }
        })
      }
    },
    //千分位组件值回写
    setVal(keyName, val) {
      this.formData[keyName] = val
    },
    //取消/关闭弹窗
    beforeCloseDialog() {
      this.$emit('closePaymentConfirm')
    },
    //提交订单确认
    submit() {
      this.loading = true
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (!this.isEdit) {
            this.$http.post('${third}/costcenter/third_payment/reviewer', this.formData).then((res) => {
              this.loading = false
              if (res.data.state) {
                this.$emit('closePaymentConfirm')
                this.$message.info('付款确认成功！')
              }
            })
          } else {
            this.$http.put('${third}/costcenter/third_payment/reviewer', this.formData).then((res) => {
              this.loading = false
              if (res.data.state) {
                this.$emit('closePaymentConfirm')
                this.$message.info('付款确认成功！')
              }
            })
          }
        } else {
          this.loading = false
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
.dialog-header-title {
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.dialog-header-title > span {
  border-left: 3px solid #2761ff;
  font-weight: 700;
  font-size: 14px;
  padding-left: 10px;
  color: #666;
}
/deep/.el-dialog__body {
  padding: 10px 20px 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
.botton_button {
  display: flex;
  text-align: center;
  justify-content: center;
}
.form_head_title {
  height: 35px;
  color: #377cff;
  font-size: 16px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
/deep/.el-form-item--mini.el-form-item {
  margin-bottom: 0px;
}
.tips {
  padding-left: 120px;
  font-size: 14px;
  color: #101010;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
</style>
